// extracted by mini-css-extract-plugin
module.exports = {"w19zkbbg":"w19zkbbg","s1atvwuu":"s1atvwuu"};